'use client';
import DirectoryApi from '@/api/directory/directory';
import {DirectoryCategoryList} from '@/components/main/directory/DirectoryCategoryList';
import {DirectoryCategoryTitle} from '@/components/main/directory/DirectoryCategoryTitle';
import {DIRECTORY_INIT_LIST, DIRECTORY_LIST_CNT} from '@/constants/main';
import useDirectoryStore from '@/stores/directory';
import {useEffect, useState} from 'react';
import '/public/static/css/module/category.scss';
import useGlobalUIStore from '@/stores';
import {isLogin} from '@/utils/main';

export const DirectoryCategory = () => {
  const [page, setPage] = useState(1);
  const [categoryList, setCategoryList] = useState({});
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const {selectedCategoryListOrder, setSelectedCategoryListOrder} =
    useDirectoryStore();
  const {refreshTimestamp} = useGlobalUIStore();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 300); //검색할때마다 호출보다는 디바운싱처리를 줘서 입력이 끝나고 나서 api 호출

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  useEffect(() => {
    if (refreshTimestamp) {
      setPage(1);
      setSearchText('');
      setSelectedCategoryListOrder(selectedCategoryListOrder);
      setCategoryList(DIRECTORY_INIT_LIST);
      window.scrollTo(0, 0);
    }
  }, [refreshTimestamp]);

  useEffect(() => {
    getCategoryList();
  }, [page, selectedCategoryListOrder, debouncedSearchText, refreshTimestamp]);

  const getCategoryList = async () => {
    try {
      const queryParams = {
        m: 'categoryList',
        szKeyword: debouncedSearchText,
        szOrder:
          !isLogin() && selectedCategoryListOrder === 'prefer' // 필터 "선호" 상태로 로그아웃 시에 대한 예외 처리
            ? 'view_cnt'
            : selectedCategoryListOrder,
        nPageNo: page,
        nListCnt: DIRECTORY_LIST_CNT,
        nOffset: categoryList?.offset ? categoryList.offset : 0,
        szPlatform: 'pc',
      };
      const response = await DirectoryApi.getCategoryList(queryParams);
      if (response) {
        if (page > 1) {
          setCategoryList({
            isMore: response.isMore,
            offset: response.offset,
            list: [...categoryList.list, ...response.list],
          });
        } else {
          setCategoryList({
            isMore: response.isMore,
            offset: response.offset,
            list: [...response.list],
          });
        }
      }
    } catch (error) {
      setCategoryList(DIRECTORY_INIT_LIST);
    }
  };

  const handleOnChangeSearch = (e) => {
    if (e.target.value.length > 50) {
      return;
    }
    setPage(1);
    setSearchText(e.target.value);
  };

  const handleOnClickSort = (type) => {
    if (type === selectedCategoryListOrder) {
      // 이전과 동일한 필터 선택시 아무것도 하지 않는다.
      return;
    }
    setPage(1);
    setSelectedCategoryListOrder(type);
    setCategoryList(DIRECTORY_INIT_LIST);
  };

  const handleOnClickMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handleOnClickClearSearchText = () => {
    setPage(1);
    setSearchText('');
  };

  const directoryCategoryTitleProps = {
    order:
      !isLogin() && selectedCategoryListOrder === 'prefer' // 필터 "선호" 상태로 로그아웃 시에 대한 예외 처리
        ? 'view_cnt'
        : selectedCategoryListOrder,
    searchText,
    handleOnClickSort,
    handleOnChangeSearch,
    handleOnClickClearSearchText,
  };

  const directoryCategoryListProps = {
    searchText,
    categoryList,
    handleOnClickMore,
  };

  return (
    <>
      <DirectoryCategoryTitle {...directoryCategoryTitleProps} />
      <DirectoryCategoryList {...directoryCategoryListProps} />
    </>
  );
};
